import { IFilterElement } from "@saleor/components/Filter";
import {
  CouponRedemptionFilterKeys,
  CouponRedemptionListUrlFilterOpts
} from "@saleor/coupons/components/CouponRedemptionListPage/filters";
import {
  CouponRedemptionListUrlFilters,
  CouponRedemptionListUrlFiltersEnum,
  CouponsRedemptionListUrlFilterWithMultipleValues,
  CouponsRedemptionListUrlQueryParams
} from "@saleor/coupons/url";
import { findValueInEnum, joinDateTime, maybe } from "@saleor/misc";
import {
  CouponRedemptionFilterInput,
  CouponRedemptionStatusEnum
} from "@saleor/types/globalTypes";
import {
  createFilterUtils,
  dedupeFilter,
  getGteLteVariables,
  getMinMaxQueryParam,
  getMultipleEnumValueQueryParam
} from "@saleor/utils/filters";

export const COUPON_REDEMPTION_FILTER_KEY = "couponRedemptionFilters";

export function getFilterOpts(
  params: CouponRedemptionListUrlFilters
): CouponRedemptionListUrlFilterOpts {
  return {
    dateRange: {
      active: maybe(
        () =>
          [params.claimedDate, params.redeemedDate].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params?.claimedDate, ""),
        min: maybe(() => params?.redeemedDate, "")
      }
    },
    status: {
      active: maybe(() => params.status !== undefined, false),
      value: maybe(
        () =>
          dedupeFilter(
            params.status.map(status =>
              findValueInEnum(status, CouponRedemptionStatusEnum)
            )
          ),
        []
      )
    }
  };
}

export function getFilterVariables(
  params: CouponRedemptionListUrlFilters
): CouponRedemptionFilterInput {
  const startTime = "00:00";
  const endTime = "23:59";
  return {
    date: getGteLteVariables({
      gte: joinDateTime(params.claimedDate, startTime) || null,
      lte: joinDateTime(params.redeemedDate, endTime) || null
    }),
    search: params.query,
    status:
      params.status &&
      params.status.map(status =>
        findValueInEnum(status, CouponRedemptionStatusEnum)
      )
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<CouponRedemptionFilterKeys>
): CouponRedemptionListUrlFilters {
  const { name } = filter;

  switch (name) {
    case CouponRedemptionFilterKeys.status:
      return getMultipleEnumValueQueryParam(
        filter,
        CouponsRedemptionListUrlFilterWithMultipleValues.status,
        CouponRedemptionStatusEnum
      );

    case CouponRedemptionFilterKeys.dateRange:
      return getMinMaxQueryParam(
        filter,
        CouponRedemptionListUrlFiltersEnum.claimedDate,
        CouponRedemptionListUrlFiltersEnum.redeemedDate
      );
  }
}

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  CouponRedemptionListUrlFilters,
  CouponsRedemptionListUrlQueryParams
>({
  ...CouponRedemptionListUrlFiltersEnum,
  ...CouponsRedemptionListUrlFilterWithMultipleValues
});
